var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tz-switch",class:{ 'tz-switch--disabled': _vm.isDisabled },on:{"click":_vm.toggleCheck}},[_c('div',{staticClass:"tz-switch__toggle",class:{
      'tz-switch__toggle--on': _vm.isToggled,
      'tz-switch__toggle--off': !_vm.isToggled
    }},[_c('input',{staticClass:"tz-switch__input",attrs:{"name":_vm.name,"type":"checkbox","id":_vm.name,"model":_vm.isToggled}}),_vm._v(" "),_c('span',{staticClass:"tz-switch__slider",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"tz-switch__label",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }